<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />
    
    <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
<userLeft :active="7" />
      <div class="box5">
        <div style="overflow: hidden;">
          <div class="box6" style="float: left;">投诉/建议详情</div>
        </div>
        <div class="box7"></div>
        
        <div class="box12">
          <div class="box13" style="text-align: left;">手机号：<span style="color: #2B9A34;">13800138000</span></div>
          <div class="box13">当前状态：<span style="color: #2B9A34;">已完结</span></div>
          <div class="box13">更新时间：<span style="color: #2B9A34;">2020-09-28  19:40:24</span></div>
          <router-link to="/my_feedback"><div class="box13" style="text-align: right;">返回列表 ></div></router-link>
        </div>
 
        <!-- <div class="box12">
          <div class="box13" style="text-align: left;"><img src="" class="message_left_img" alt=""></div>
          <div class="box13">          <div class="message_details_title">反馈内容<span style="margin-left: 4%;">反馈类型：<span style="color: #2B9A34;">XXXX</span></span></div>
        </div>
          <div class="box13">更新时间：<span style="color: #2B9A34;">2020-09-28  19:40:24</span></div>
          <div class="box13" style="text-align: right;">返回列表 ></div>
        </div> -->

        <div style="margin-top: 0; background: none; border-top: 1px dashed #EEEEEE; padding: 2% 0; overflow: hidden;">
          <div style="overflow: hidden;">
            <img src="" class="message_left_img" alt="">
          <div class="message_details_title" style="margin-left: 5%;">反馈内容<span style="margin-left: 10%;">反馈类型：<span style="color: #2B9A34;">XXXX</span></span></div>
          <div class="message_details_time">2020-09-28  18:03:25</div>
          </div>
          <div class="message_details_info">我要投诉建议反馈我要投诉建议反馈我要投诉建议反馈我要投诉建议反馈我要投诉建议反馈我要投诉建议反馈</div>
        </div>

        <a-divider :dashed="true" style="color: #999999;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;">您对以上内容回复是否满意？</a-divider>
        <div style="margin: 4% auto; width: 40%;">
          <a-row :gutter="16">
            <a-col class="gutter-row" :span="8">
              <div class="gutter-box">
                <a-button type="dashed" icon="search">
                  满意
                </a-button>
              </div>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <div class="gutter-box">
                <a-button type="dashed" icon="search">
                  一般
                </a-button>
              </div>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <div class="gutter-box">
                <a-button type="dashed" icon="search">
                  不满意
                </a-button>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <foot/>
  </div>
</template>

<script>
    import axios from "axios";
    import userLeft from "../public/user_left";
    import htmlHeader from "../public/head";
import foot from "../public/foot";
    export default {
        name: "integral",
          components: {
    userLeft,
        htmlHeader,
    foot,
  },
        data() {
            return {

            };
        },
        methods: {

        },
        created() {

        },
    };
</script>

<style scoped>

  .message_details_info {
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #000000;
text-align: left;
margin-top: 2%;

  }
    .message_details_time {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        float: right;
    }
    
    .message_details_title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        /* line-height: 16px; */
        float: left;
        width: 20%;
    }
    
    .message_left_img {
        width: 24px;
        height: 24px;
        background: #E0E0E0;
        border-radius: 50%;
        float: left;
    }
    
    .box14 {
        width: 120px;
        height: 32px;
        border: 1px solid #2C9A34;
        float: right;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2C9A34;
    }
    
    .box13 {
        width: 25%;
        height: 100%;
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
    }
    
    .box12 {
        width: 100%;
        height: 40px;
        /* background: #F4F4F4; */
        margin-top: 4%;
    }
    
    .box11 {
        width: 100px;
        height: 32px;
        border: 1px solid #2B9A34;
        margin: 8% auto;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
    }
    
    .box10 {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FF9629;
        /* line-height: 16px; */
        margin: 4% auto;
    }
    
    .box9 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin: auto;
    }
    
    .box8 {
        width: 100%;
        height: 105px;
        background: EEF7EF;
        /* opacity: 0.08; */
        padding-top: 4%;
    }
    
    .box7 {
        width: 100%;
        height: 1px;
        border-top: 1px solid #E8E6E6;
        margin-top: 2%;
    }
    
    .box6 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        /* margin-top: 2%; */
        text-align: left;
    }
    
.box5 {
        min-height: 1023px;
        width: 80%;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: right;
        margin-top: 2%;
        padding: 2%;
    }
    
    .box3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: Regular;
        color: #666666;
        margin-top: 6%;
    }
    
    .box4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }
    
    .box1 {
        width: 220px;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: left;
        margin-top: 2%;
    }
    
    .box2 {
        width: 100%;
        height: 45px;
        background: #F2F2F2;
    }
</style>


// WEBPACK FOOTER //
// src/components/message_details.vue